import { Field, ImageField, Item, LinkField } from '@sitecore-jss/sitecore-jss-react';

export type PromotedContentFields = {
  title: Field<string>;

  description: Field<string>;

  ctaLink: LinkField;

  image: ImageField;
};

export type PromotedContentProps = {
  id: string;

  fields: PromotedContentFields;
};

export type NavItemFields = {
  items: Array<NavItem>;
  pulloutLink: LinkField;
  link: LinkField;
  title: Field<string>;
  description: Field<string>;
  promotedContent: Item & { fields: PromotedContentFields; id: string };
  languageSelector: Field<boolean>;
  changeSite: Field<boolean>;
};

export type NavItem = Omit<Item, 'fields'> & {
  fields: NavItemFields;
  hasLinks?: boolean;
  directLink?: LinkField;
  hideTitle: boolean;
};
